"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.withRequest = exports.rbiLogger = exports.logger = exports.create = exports.LOG_LEVEL = void 0;
const pino_1 = require("pino");
const pino_lambda_1 = __importDefault(require("pino-lambda"));
/**
 * Available log levels
 */
var LOG_LEVEL;
(function (LOG_LEVEL) {
    LOG_LEVEL["TRACE"] = "trace";
    LOG_LEVEL["DEBUG"] = "debug";
    LOG_LEVEL["INFO"] = "info";
    LOG_LEVEL["WARN"] = "warn";
    LOG_LEVEL["ERROR"] = "error";
    LOG_LEVEL["FATAL"] = "fatal";
})(LOG_LEVEL = exports.LOG_LEVEL || (exports.LOG_LEVEL = {}));
/**
 * A CustomErrorSerializer that adds "request" and "response" attributes to the
 * serialized error (when present).
 */
const errSerializer = (err) => {
    const errRequest = (err === null || err === void 0 ? void 0 : err.request) ? { request: pino_1.stdSerializers.req(err.request) } : {};
    const errResponse = (err === null || err === void 0 ? void 0 : err.response) ? { response: pino_1.stdSerializers.res(err.response) } : {};
    return { ...err, ...errRequest, ...errResponse };
};
const defaultOptions = {
    // track stage, brand, and region tags on all logs
    base: {
        brand: (_a = process.env.BRAND) === null || _a === void 0 ? void 0 : _a.toLowerCase(),
        stage: (_b = (process.env.STAGE || process.env.NODE_ENV)) === null || _b === void 0 ? void 0 : _b.toLowerCase(),
    },
    // allow log supression
    enabled: ((_c = process.env.LOG_LEVEL) === null || _c === void 0 ? void 0 : _c.toLowerCase()) !== 'silent',
    // reformat the level to a label instead of integer
    formatters: {
        level(label, level) {
            return { level, level_label: label };
        },
    },
    // set the level by env variable or use the defaults
    level: ((_d = process.env.LOG_LEVEL) === null || _d === void 0 ? void 0 : _d.toLowerCase()) || LOG_LEVEL.INFO,
    // set the lambda name to make debugging easier
    name: ((_e = process.env.AWS_LAMBDA_FUNCTION_NAME) === null || _e === void 0 ? void 0 : _e.toLowerCase()) || 'default',
    // enable pretty print for local development
    prettyPrint: process.env.LOG_PRETTY === 'true',
    serializers: {
        err: pino_1.stdSerializers.wrapErrorSerializer(errSerializer),
        error: pino_1.stdSerializers.wrapErrorSerializer(errSerializer),
    },
};
/**
 * Creates a named logger instance
 * @param name The name of the logger, emitted on log entries
 */
const create = (options) => {
    return pino_lambda_1.default({ ...defaultOptions, ...options });
};
exports.create = create;
/**
 * A default instance of a logger
 */
exports.logger = exports.create({});
/**
 * A default instance of a logger
 */
exports.rbiLogger = exports.logger;
/**
 * A default instance of a logger
 */
exports.default = exports.logger;
/**
 * Track event and context tags with each log entry
 */
const withRequest = (event, context) => {
    exports.logger.withRequest(event, context);
};
exports.withRequest = withRequest;
//# sourceMappingURL=pino.js.map